<div class="uk-child-width-1-2@s uk-child-width-1-4@m" uk-grid><Attribute label="Bundle ID">{{ spec.bundle_id }}</Attribute></div>